import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { exportMaisEguByIdFailed, exportMaisEguByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* exportMaisEguById(action) {
  try {
    const url = `${BACKEND_URL}/resources/mais-egu-types/${action.payload}/export-order`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.blob();
      yield put(exportMaisEguByIdSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(exportMaisEguByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(exportMaisEguByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
